export default "__VITE_ASSET__7cx1Kg7v__"